import { RouterProvider } from "@tanstack/react-router";

import { createTanstackRouter } from "@/react/utils/router/createTanstackRouter";

import { authRouteTree } from "./routeTree";

interface AuthenticationAppRouterProps {
  hasEmail: boolean;
}

export const authRouter = createTanstackRouter({
  routeTree: authRouteTree,
  context: {
    hasEmail: false,
  },
});

export const AuthenticationAppRouter = ({
  hasEmail,
}: AuthenticationAppRouterProps) => (
  <RouterProvider router={authRouter} context={{ hasEmail }} />
);
